export default __webpack_public_path__ + "static/media/app_store.5173d1b8.svg";